import { TagType } from 'types/tag'

export const FETCH_TAGS = 'FETCH_TAGS'
export const fetchTagsAction = (tags: TagType[]) => {
  return {
    type: 'FETCH_TAGS',
    payload: tags,
  }
}
